/* eslint-disable max-len */
import { configureStore } from '@reduxjs/toolkit';
import { IS_DEV } from '@/constant/config';
import { actions, reducers } from './slices';

const AppStore = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
  devTools: IS_DEV,
});

type IStoreState = ReturnType<typeof AppStore.getState>

export { actions, AppStore, IStoreState };
